<section class="relative rounded-large border white-bg overflow-hidden mr-large-b">
  <div class="offer-area grow">
    <section class="destination-image relative" *ngIf="aspectRatio$ | async">
      <fin-content-image [aspectRatio$]="aspectRatio$" [imageData$]="cmsImage | finToObservable"> </fin-content-image>
    </section>

    <fcom-tag class="ms-medium-l ms-medium-t absolute top-left">
      <fcom-icon [name]="SvgLibraryIcon.AVIOS_PLECTRUM" class="icon-small"></fcom-icon>
      <span class="ms-xsmall-l">{{ 'MMB.carRentalTab.collectAvios' | finLocalization }}</span>
    </fcom-tag>

    <section class="fill ps-medium">
      <h4 class="font-heading-4">{{ 'MMB.carRentalTab.transfersTitle' | finLocalization }}</h4>
      <p class="font-body-1 ms-xsmall-t">
        {{ 'MMB.carRentalTab.transfersDescription' | finLocalization }}
      </p>
      <div class="button-wrapper flex flex--middle flex--space-between flex--nowrap font-body-1 ms-medium-t">
        <div class="flex flex--wrap">
          <div class="ps-xxsmall-r" [innerHTML]="'bookingWidgetTabs.carTrawler.poweredBy' | finLocalization"></div>
          <fcom-icon
            class="cartrawler-logo"
            [category]="IconLibrary.CUSTOM"
            [name]="CustomIcon.CARTRAWLER_LOGO"
          ></fcom-icon>
        </div>
        <fcom-button
          [text]="'MMB.carRentalTab.transfersCtaButton' | finLocalization"
          [icon]="{
            name: SvgLibraryIcon.EXTERNAL_TAB,
            position: IconPosition.RIGHT,
          }"
          [href]="(deeplink$ | async).url"
          [openInNewTab]="true"
          [externalLink]="true"
        ></fcom-button>
      </div>
    </section>
  </div>
</section>
